<template>
  <section>
    <v-dialog v-model="dialog" persistent max-width="750px">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <v-flex v-if="!Update_Details">Add Job SEO</v-flex>
          <v-flex v-else>Update Job SEO</v-flex>
          <v-btn icon @click="CloseDialog">
            <v-icon color="text--secondary">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex wrap style="padding: 10px;">
            <v-flex>
              <v-select v-if="!Update_Details"
                        item-value="_id"
                        item-text="name"
                        return-object
                        v-model="SelectedJobDetail"
                        :items="JobList"
                        label="Select Job">
                <template slot="selection" slot-scope="{ item }">{{ item.Job_Title }}</template>
                <template slot="item" slot-scope="{ item }">{{ item.Job_Title }}</template>
              </v-select>
              <v-flex v-else style="font-size: 18px;font-weight: bold;padding: 10px;">Job Title : {{ SelectedJobDetail.Job_Title }}</v-flex>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Keywords" v-model="Meta_Keywords"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Description" v-model="Meta_Description"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Abstract" v-model="Meta_Abstract"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Author" v-model="Meta_Author"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Copyright" v-model="Meta_Copyright"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Distribution" v-model="Meta_Distribution"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Item Prop Name" v-model="Meta_Item_Prop_Name"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Item Prop Description" v-model="Meta_Item_Prop_Description"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Item Prop Image" v-model="Meta_Item_Prop_Image"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Property OG Type" v-model="Meta_Property_OG_Type"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Property OG URL" v-model="Meta_Property_OG_URL"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Property OG SiteName" v-model="Meta_Property_OG_SiteName"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Property OG Title" v-model="Meta_Property_OG_Title"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Property OG Description" v-model="Meta_Property_OG_Description"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Property OG Author" v-model="Meta_Property_OG_Author"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Property OG Image" v-model="Meta_Property_OG_Image"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Property Article Author" v-model="Meta_Property_Article_Author"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Property Article Publisher" v-model="Meta_Property_Article_Publisher"></v-text-field>
            </v-flex>
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-flex style="text-align: right;">
            <v-btn color="primary" v-if="!Update_Details" @click="SubmitJobSEO">Add Job SEO</v-btn>
            <v-btn color="primary" v-else @click="SubmitJobSEO">Update Job SEO</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor
  },
  props: ["dialog"],
  data() {
    return {

      Update_Details: false,
      SelectedJobDetail: {},
      Meta_Keywords: "",
      Meta_Description: "",
      Meta_Abstract: "",
      Meta_Author: "",
      Meta_Copyright: "",
      Meta_Distribution: "",
      Meta_Item_Prop_Name: "",
      Meta_Item_Prop_Description: "",
      Meta_Item_Prop_Image: "",
      Meta_Property_OG_Type: "",
      Meta_Property_OG_URL: "",
      Meta_Property_OG_SiteName: "",
      Meta_Property_OG_Title: "",
      Meta_Property_OG_Description: "",
      Meta_Property_OG_Author: "",
      Meta_Property_OG_Image: "",
      Meta_Property_Article_Author: "",
      Meta_Property_Article_Publisher: "",
      JobList : []
    };
  },
  methods: {
    CloseDialog() {
      this.ClearForm();
      this.$emit("close");
    },
    SubmitJobSEO() {

      let JobSEO = {};
      JobSEO["Job_Id"] = this.SelectedJobDetail["_id"];
      JobSEO["update"] = {};
      JobSEO["update"]["Meta_Keywords"] = this.Meta_Keywords;
      JobSEO["update"]["Meta_Description"] = this.Meta_Description;
      JobSEO["update"]["Meta_Abstract"] = this.Meta_Abstract;
      JobSEO["update"]["Meta_Author"] = this.Meta_Author;
      JobSEO["update"]["Meta_Copyright"] = this.Meta_Copyright;
      JobSEO["update"]["Meta_Distribution"] = this.Meta_Distribution;
      JobSEO["update"]["Meta_Item_Prop_Name"] = this.Meta_Item_Prop_Name;
      JobSEO["update"]["Meta_Item_Prop_Description"] = this.Meta_Item_Prop_Description;
      JobSEO["update"]["Meta_Item_Prop_Image"] = this.Meta_Item_Prop_Image;
      JobSEO["update"]["Meta_Property_OG_Type"] = this.Meta_Property_OG_Type;
      JobSEO["update"]["Meta_Property_OG_URL"] = this.Meta_Property_OG_URL;
      JobSEO["update"]["Meta_Property_OG_SiteName"] = this.Meta_Property_OG_SiteName;
      JobSEO["update"]["Meta_Property_OG_Title"] = this.Meta_Property_OG_Title;
      JobSEO["update"]["Meta_Property_OG_Description"] = this.Meta_Property_OG_Description;
      JobSEO["update"]["Meta_Property_OG_Author"] = this.Meta_Property_OG_Author;
      JobSEO["update"]["Meta_Property_OG_Image"] = this.Meta_Property_OG_Image;
      JobSEO["update"]["Meta_Property_Article_Author"] = this.Meta_Property_Article_Author;
      JobSEO["update"]["Meta_Property_Article_Publisher"] = this.Meta_Property_Article_Publisher;
    
      this.$http.post(`${this.$store.getters.GetProductionUrl}/courseseo/addjobseo`,JobSEO)
                .then(response => {

                this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: `Successfully Added Job SEO`,Color: "green", Close: false });
                this.CloseDialog();
                })
                .catch(err => {

                this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Failed To Add Job SEO", Color: "red", Close: false });
                });
    },
    ClearForm() {

        this.SelectedJobDetail = {};
        this.Meta_Keywords = "";
        this.Meta_Description = "";
        this.Meta_Abstract = "";
        this.Meta_Author = "";
        this.Meta_Copyright = "";
        this.Meta_Distribution = "";
        this.Meta_Item_Prop_Name = "";
        this.Meta_Item_Prop_Description = "";
        this.Meta_Item_Prop_Image = "";
        this.Meta_Property_OG_Type = "";
        this.Meta_Property_OG_URL = "";
        this.Meta_Property_OG_SiteName = "";
        this.Meta_Property_OG_Title = "";
        this.Meta_Property_OG_Description = "";
        this.Meta_Property_OG_Author = "";
        this.Meta_Property_OG_Image = "";
        this.Meta_Property_Article_Author = "";
        this.Meta_Property_Article_Publisher = "";
    },
    GetJobsList() {

        this.$http.post(`${this.$store.getters.GetProductionUrl}/joblisting/getjoblistings`)
                .then(response => {
                   if(response["data"] && response["data"]["response"] && response["data"]["response"].length > 0){
                       this.JobList = response["data"]["response"]
                   }else{
                       this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Error While Fetching Data",Color: "red",Close: false });
                   }
                })
                .catch(err => {

                    this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Error While Fetching Data",Color: "red",Close: false });
                });
    }
  }
};
</script>
<style>
</style>